/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { Severity, withSnackbar } from '../Snackbar/Snackbar';
import GlobalLoader from '../GlobalLoader/GlobalLoader';

import AdminService from '../../core/services/admin-api-service';
import { base64ToArrayBuffer, downloadBlob } from '../../core/helpers/download';

import redirectIfUnauthorized from '../../core/helpers/redirect-if-unauthorized';
import UnauthorizedError from '../../core/errors/UnauthorizedError';
import authApi from '../../core/services/auth-api-service';

const apiService = new AdminService();
const ac = new AbortController();

interface IActions {
  showSnackbar: (msg: string, sev?: Severity, dur?: number) => void;
}

function DownloadButton({ showSnackbar }: IActions): JSX.Element {
  const history = useHistory();

  const [pending, setPending] = useState<boolean>(false);
  const isAdmin = sessionStorage.getItem('isAdmin') ?? false;

  const urlQuery = new URLSearchParams(window.location.search);
  const keyParam = urlQuery.get('key') || '';

  // useEffect(() => {
  //   return () => ac.abort();
  // }, []);

  const downloadPdf = () => {
    setPending(true);

    apiService
      .downloadPdf({ key: isAdmin ? 'admin' : keyParam }, ac)
      .catch((err) => {
        if (err instanceof UnauthorizedError && keyParam) {
          return authApi
            .validateUserKey(keyParam)
            .then((response) => response.json())
            .then((data) => {
              window.sessionStorage.setItem('token', data.token);
            })
            .then(() => apiService.downloadPdf({ key: isAdmin ? 'admin' : keyParam }, ac));
        }
        return Promise.reject(err);
      })
      .then(async (result) => {
        // const fileName = getFileNameFromContentDisposition(result);
        const jsonResult = await result.json();
        const arrayBuffer = base64ToArrayBuffer(jsonResult.file);
        downloadBlob(arrayBuffer, jsonResult.filename, 'pdf');
      })
      .catch((err) => {
        // ac.abort();
        showSnackbar(`Something went wrong! Try again.`, Severity.ERROR);
        console.error(err);

        if (!keyParam) {
          redirectIfUnauthorized(err, history);
        }
      })
      .finally(() => {
        setPending(false);
      });
  };

  return (
    <>
      <button className="emp-btn" type="button" onClick={downloadPdf}>
        <span className="button-text">Download PDF</span>
      </button>

      {pending ? <GlobalLoader /> : null}
    </>
  );
}

export default withSnackbar(DownloadButton);
